import * as Styled from './styles';
import { ReactComponent as AddIcon } from '../../../assets/image/add_icon.svg';
import { ReactComponent as AttachIcon } from '../../../assets/image/attach_icon.svg';

type IconButtonPropsType = {
  margin?: string;
  icon: 'ADD' | 'ATTACH';
  label: string;
  onClick: () => void;
};

const IconButton = (props: IconButtonPropsType) => {
  return (
    <Styled.Button
      type='button'
      margin={props.margin ? props.margin : '0'}
      onClick={props.onClick}
    >
      {props.icon === 'ADD' ? <AddIcon /> : <AttachIcon />}
      <Styled.Label>{props.label}</Styled.Label>
    </Styled.Button>
  );
};

export default IconButton;
